const getModalTokens = (tokens) => {
    return tokens.component.modal;
};
const dialog = (tokens) => {
    const { header, content, borderRadius, boxShadow, maxWidth, footer, overlay } = getModalTokens(tokens);
    const border = `${content.borderWidth.value} ${content.borderTopStyle.value} ${content.borderColor.value}`;
    return {
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontWeight: header.fontWeight.value,
                    fontSize: header.fontSize.value,
                    lineHeight: header.lineHeight.value,
                    color: header.color.value,
                    padding: `${header.paddingVertical.value} ${header.paddingHorizontal.value}`,
                    // need flexbox for close icon
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: header.gap.value,
                    wordBreak: "break-word",
                    // override default style
                    "+.MuiDialogContent-root": {
                        paddingTop: ` ${content.padding.value}!important`,
                    },
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    borderTop: border,
                    borderBottom: border,
                    padding: content.padding.value,
                },
            },
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    color: content.color.value,
                    fontSize: content.fontSize.value,
                    fontWeight: content.fontWeight.value,
                    lineHeight: content.lineHeight.value,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: `${footer.paddingVertical.value} ${footer.paddingHorizontal.value}`,
                    gap: footer.gap.value,
                    "div + div": {
                        display: "flex",
                        gap: footer.gap.value,
                    },
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    "&:not(.MuiBackdrop-invisible)": {
                        backgroundColor: overlay.backgroundColor.value,
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: borderRadius.value,
                    boxShadow: boxShadow.value.stringValue,
                    maxWidth: maxWidth.value,
                    width: maxWidth.value,
                },
                paperFullScreen: {
                    maxWidth: "100%",
                    width: "100%",
                },
            },
        },
    };
};
export default dialog;
//# sourceMappingURL=dialog.js.map